import { Field } from 'formik';

import { BaseRadioGroup } from '../BaseRadioGroup/BaseRadioGroup';

export const RadioGroupField = ({ name, label, options, value }) => (
  <Field
    component={BaseRadioGroup}
    name={name}
    label={label}
    options={options}
    value={value}
    data-testid={name}
  />
);

export default RadioGroupField;
